import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, apiCall } from '../services/authService';

/**
 * ProtectedRoute Component
 * Wraps protected components and ensures user is authenticated
 * Redirects to login if not authenticated
 * Validates token with backend before rendering component
 */
const ProtectedRoute = ({ children }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const validateAuthentication = async () => {
      console.log(' [PROTECTED ROUTE] Validating authentication...');
      
      // Check if user has local authentication data
      if (!isAuthenticated()) {
        console.log(' [PROTECTED ROUTE] No local authentication found');
        setIsValidating(false);
        setIsValid(false);
        return;
      }

      try {
        // Validate token with backend by making a test API call
        console.log(' [PROTECTED ROUTE] Validating token with backend...');
        const response = await apiCall('/test');
        
        if (response && response.ok) {
          console.log('[PROTECTED ROUTE] Token validation successful');
          setIsValid(true);
        } else {
          console.log(' [PROTECTED ROUTE] Token validation failed');
          setIsValid(false);
        }
      } catch (error) {
        console.error(' [PROTECTED ROUTE] Token validation error:', error);
        setIsValid(false);
      } finally {
        setIsValidating(false);
      }
    };

    validateAuthentication();
  }, [location.pathname]);

  // Show loading state while validating
  if (isValidating) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #3498db',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '20px'
        }}></div>
        <p style={{ color: '#666', fontSize: '16px' }}>Validating authentication...</p>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isValid) {
    console.log(' [PROTECTED ROUTE] Redirecting to login...');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Render protected component if authenticated
  console.log(' [PROTECTED ROUTE] Rendering protected component');
  return children;
};

export default ProtectedRoute;